import { FOfferType } from './types';

export function isUrban(offerType: FOfferType): boolean {
  return (offerType & FOfferType.Urban) !== 0;
}

export function isSuburban(offerType: FOfferType): boolean {
  return (offerType & FOfferType.Suburban) !== 0;
}

export function isCommercial(offerType: FOfferType): boolean {
  return (offerType & FOfferType.Commercial) !== 0;
}

export function isResidential(offerType: FOfferType): boolean {
  return (offerType & FOfferType.Residential) !== 0;
}

export function isFlat(offerType: FOfferType): boolean {
  return (offerType & FOfferType.Flat) !== 0;
}

export function isHotel(offerType: FOfferType): boolean {
  return (offerType & FOfferType.Hotel) !== 0;
}
